var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHasTransfers(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 11.5V4.034C4.5 2.102 6.067.5 8 .5h7c1.934 0 3.5 1.602 3.5 3.534V11.5m-15 10h3v2h-3v-2zm13 0h3v2h-3v-2zm-16-17h2v5h-2v-5zm20 0h2v5h-2v-5zM1.5 20A1.5 1.5 0 003 21.5h17a1.5 1.5 0 000-3H3A1.5 1.5 0 001.5 20zM20.437 4.5H2.5m15 9.5a1 1 0 110 2 1 1 0 010-2zm-12 0a1 1 0 110 2 1 1 0 010-2zm6-9.5v7m-2 3h4.016m-4.016 2h4.016",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 13.5a2 2 0 012-2h14c1.103 0 2 .896 2 2v5h-18v-5zm18-4l-2 2m-16-2l2 2",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2a.5.5 0 10.002 1.002A.5.5 0 0015.5 2zm-8 0a.5.5 0 100 1 .5.5 0 000-1z"
  })));
}
export default SvgHasTransfers;